import type { Stripe, StripeElementLocale } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { LoadingDots } from '@_/ui';

export function StripeElementsProvider({
  baseUrl,
  children,
  stripePublicKey
}: {
  baseUrl: string;
  children: React.ReactNode;
  stripePublicKey: string;
}) {
  const { locale } = useIntl();
  const [stripe, setStripe] = useState<Stripe | null>();

  useEffect(() => {
    const load = async () => {
      setStripe(await loadStripe(stripePublicKey));
    };
    if (stripePublicKey) {
      void load();
    }
  }, [stripePublicKey]);

  if (!stripe) {
    return <LoadingDots />;
  }

  return (
    <Elements
      options={{
        fonts: [
          {
            family: 'Inter',
            weight: '400',
            src: !import.meta.env.DEV
              ? `local("Inter"), url(${baseUrl}/fonts/Inter-Regular.woff2) format("woff")`
              : `local("Inter")`
          }
        ],
        locale: locale as StripeElementLocale
      }}
      stripe={stripe}
    >
      {children}
    </Elements>
  );
}
